<template lang="pug">
.skeleton.h-16
</template>

<style scoped src="./skeleton.css"></style>
